<matchmaking-form-content [contentImage]="content().mappedImage">
    <matchmaking-form-option-list>
        @if (isCustomPage() && customPageQuestions()) {
            <matchmaking-dynamic-question
                [questions]="customPageQuestions()!"
                [selectedQuestions]="selectedQuestions()!"
                (updateQuestionAnswer)="setQuestion($event)"
                data-cy="dynamic-questions">
            </matchmaking-dynamic-question>
        } @else {
            <matchmaking-form-textarea-input
                [answer]="otherAnswer()"
                (updateQuestionAnswer)="setOtherQuestion($event)"
                [shouldFocus]="true"
                data-cy="fallback-question">
            </matchmaking-form-textarea-input>
        }
    </matchmaking-form-option-list>

    <div class="buttons-container">
        <matchmaking-form-back-button
            (click)="handleBack()"
            [text]="translations()!.button.back"
            data-cy="back-button">
        </matchmaking-form-back-button>
        <matchmaking-form-submit-button
            data-cy="submit-button"
            [text]="translations()!.button.defineGoal"
            [isDisabled]="isSubmitDisabled()"
            (triggerSubmitEvent)="submit()">
        </matchmaking-form-submit-button>
    </div>
</matchmaking-form-content>
